/*********************** Custom JS for Boost AI Search & Discovery  ************************/
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductSwatchOption", {
      name: "ProductSwatchOption - Custom Swatch Image Url",
      apply: () => ({
        props: (props) => {
          console.log('@customSwatches-props', props)

          if (props.labelAs === "image") {
            const _label = props.label;

            props.customSwatchImageUrl = (fileBaseUrl) => {
              const customizeName = "finishes-" + slugify(props.value); 
              return `url(${fileBaseUrl}${customizeName}.png)`;
            };
          }

          return props;
        },
      }),
    });
  },
]);

function slugify (text) {
	if (text == null || typeof text == 'object') return '';
	if (typeof text != 'string') {
		if (typeof text.toString != 'function') {
			return '';
		} else {
			text = text.toString();
		}
	}
	text = text.toLowerCase();

	// Remove Latin
	var from = "àáäâãèéëêẽìíïîĩòóöôõùúüûũñç·/_,:;";
	var to = "aaaaaeeeeeiiiiiooooouuuuunc--_---";
	for (var i = 0, l = from.length; i < l; i++)
		text = text.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));

	// Remove Czech, Finnish special characters
	var specialCzechChars = 'ÁáÄäČčĎďÉéěÍíŇňÓóÖöŘřŠšŤťÚúůÝýŽž';
	var asciiCzechChars = 'AaAaCcDdEeeIiNnOoOoRrSsTtUuuYyZz';
	var specialCzechCharsLength = specialCzechChars.length;
	for (var j = 0; j < specialCzechCharsLength; j++) {
		text = text.replace(new RegExp(specialCzechChars.charAt(j), "g"), asciiCzechChars.charAt(j));
	}

	// Remove Norway special characters
	var specialNorwayChars = 'ÆæØøÅå';
	var asciiNorwayChars = ['AE', 'ae', 'O', 'o', 'A', 'a'];
	var specialNorwayCharsLength = specialNorwayChars.length;
	for (var k = 0; k < specialNorwayCharsLength; k++) {
		text = text.replace(new RegExp(specialNorwayChars.charAt(k), "g"), asciiNorwayChars[k]);
	}

	// Remove quotes
	text = text.replace(/'/g, '').replace(/"/g, '');

	return text.replace(/[\s\/]+/g, '-')    // Replace spaces with -
		.replace(/[`~!@#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '-')   // Replace all special characters with -
		.replace(/\-\-+/g, '-')     // Replace multiple - with single -
		.replace(/^-+/, '')         // Trim - from start of text
		.replace(/-+$/, '');         // Trim - from end of text
};